import { render, staticRenderFns } from "./Imagem.vue?vue&type=template&id=0fa80ff2"
import script from "./Imagem.vue?vue&type=script&lang=js"
export * from "./Imagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports